import ItemSelector from './ItemSelector';

// 机构项组件
function OrgItem({ item, checked }) {
  return (
    <div className="flex items-center gap-3 min-w-0 flex-1">
      <div className="flex-shrink-0">
        <div
          className={`w-11 h-11 rounded-full flex items-center justify-center transition-colors ${
            checked ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-600'
          }`}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
            />
          </svg>
        </div>
      </div>

      <div className="min-w-0 flex-1">
        <div
          className={`text-sm font-medium truncate ${
            checked ? 'text-blue-700' : 'text-slate-800'
          }`}
        >
          {item.name}
        </div>
        <div
          className={`text-xs mt-0.5 truncate ${
            checked ? 'text-blue-600' : 'text-slate-500'
          }`}
        >
          {item.phone}
        </div>
      </div>
    </div>
  );
}

export default function OrgSelector({
  open,
  onClose,
  onConfirm,
  selectedItems = [],
  onToggle = () => {},
  okText = '确定',
  api = '',
  multiple = true,
  addPath,
  onCreate,
}) {
  return (
    <ItemSelector
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      selectedItems={selectedItems}
      onToggle={onToggle}
      okText={okText}
      itemComponent={OrgItem}
      api={api}
      options={[{ value: 'name', label: '机构名称' }]}
      multiple={multiple}
      addPath={addPath}
      onCreate={onCreate}
    />
  );
}
